export interface CanvasStyle {
  width?: string;
  height?: string;
  position?: string;
  margin?: string;
  top?: string;
  left?: string;
  bottom?: string;
  right?: string;
  transform?: string;
  webkitTransform?: string;
  transformOrigin?: string;
  webkitTransformOrigin?: string;
}

export class CanvasManager {
  private static canvas: HTMLElement | null = null;
  private static width: number = 0;
  private static height: number = 0;
  private static viewport: string | null = null;

  /**
   * Setup canvas
   * - setup viewport
   * - auto fit to window
   * @param canvas Canvas
   * @param width Width
   * @param height Height
   * @param viewport Viewport
   */
  public static setup(canvas: HTMLElement, width: number, height: number, viewport?: string): void {
    this.canvas = canvas;
    this.width = width;
    this.height = height;
    if (viewport) {
      this.viewport = viewport;
    }

    this.setupViewport();
    this.resize();
    window.addEventListener('resize', () => {
      this.resize();
    });
  }

  private static setupViewport(): void {
    let meta = document.querySelector('meta[name="viewport"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'viewport');
      document.head.appendChild(meta);
    }
    const viewport = this.viewport
      ? this.viewport
      : 'viewport-fit=cover, width=device-width, initial-scale=1.0, user-scalable=no';
    meta.setAttribute('content', viewport);
  }

  private static resize(): void {
    if (this.canvas) {
      Object.assign(this.canvas.style, this.canvasStyle());

      // scroll
      let scrollX = 0;
      let scrollY = 0;
      const innerWidth = window.innerWidth;
      const innerHeight = window.innerHeight;
      const scrollWidth = Math.max(document.body.scrollWidth, document.documentElement.scrollWidth);
      const scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      if (innerWidth < scrollWidth) {
        scrollX = (scrollWidth - innerWidth) / 2;
      }
      if (innerHeight < scrollHeight) {
        scrollY = (scrollHeight - innerHeight) / 2;
      }
      if (scrollX !== 0 || scrollY !== 0) {
        window.scrollTo(scrollX, scrollY);
      }
    } else {
      throw new Error('Canvas not found.');
    }
  }

  private static canvasStyle(): CanvasStyle {
    const windowRatio = {
      width: window.innerWidth,
      height: window.innerHeight
    };

    let width = 0;
    let height = 0;
    const canvasRatio = this.width / this.height;
    if (windowRatio.width / windowRatio.height >= canvasRatio) {
      width = this.toEven(windowRatio.height * canvasRatio);
      height = windowRatio.height;
    } else {
      width = windowRatio.width;
      height = this.toEven(windowRatio.width / canvasRatio);
    }

    return {
      width: `${width}px`,
      height: `${height}px`,
      position: 'absolute',
      margin: 'auto',
      top: '0px',
      left: '0px',
      bottom: '0px',
      right: '0px',
      transform: 'rotate(0deg)',
      webkitTransform: 'rotate(0deg)',
      transformOrigin: '',
      webkitTransformOrigin: ''
    };
  }

  private static toEven(value: number): number {
    let response = Math.trunc(value);
    response -= response % 2;
    return response;
  }
}
